




















import { Vue, Prop, Component } from 'vue-property-decorator';

@Component({})
export default class Arrow extends Vue {
  @Prop({ default: '10' }) readonly width?: string;
  @Prop({ default: '6' }) readonly height?: string;
  @Prop({ default: 'white' }) readonly fill?: string;
  @Prop({ default: 'down' }) readonly direction!:
    | 'down'
    | 'left'
    | 'right'
    | 'up';

  get transformStyle() {
    const translate = {
      left: 90,
      right: -90,
      down: 0,
      up: 180
    }[this.direction];

    return `transform: rotate(${translate}deg)`;
  }
}
